"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cavasso-nuovo": {
    "f608bfdd": [{
      "hkey": "a7f155fc",
      "slug": "dreon-runcis",
      "name": "Dreon-Runcis",
      "primary": true,
      "skipSearch": false
    }],
    "dreon": [{
      "hkey": "a7f155fc",
      "slug": "dreon-runcis",
      "name": "Dreon-Runcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "93b884f9": [{
      "hkey": "5731133e",
      "slug": "cavasso-nuovo",
      "name": "Cavasso Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "grilli": [{
      "hkey": "5731133e",
      "slug": "cavasso-nuovo",
      "name": "Cavasso Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "97ec8bad": [{
      "hkey": "a7f155fc",
      "slug": "dreon-runcis",
      "name": "Dreon-Runcis",
      "primary": true,
      "skipSearch": false
    }],
    "runcis": [{
      "hkey": "a7f155fc",
      "slug": "dreon-runcis",
      "name": "Dreon-Runcis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavasso-nuovo"
    }],
    "052a932e": [{
      "hkey": "5731133e",
      "slug": "cavasso-nuovo",
      "name": "Cavasso Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "vescovi": [{
      "hkey": "5731133e",
      "slug": "cavasso-nuovo",
      "name": "Cavasso Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;